// Helper function to check if an array is valid and non-empty
const isValidArray = <T>(array: T[] | null | undefined): array is T[] => {
  return Array.isArray(array) && array.length > 0;
};

export default isValidArray;
